import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllQuestionsByCategories } from '../api';
import Navbar from './Navbar';
import './Statistik.css';

const statistikTypes = [
  { key: 'lernen', label: 'Lernstatistik' },
  { key: 'pruefung', label: 'Prüfungsstatistik' },
];

// Kategorie-Namen Mapping
const categoryLabels = {
  'labor_law': 'Arbeitsrecht',
  'economic_basics': 'Wirtschaftsgrundlagen',
  'business_management': 'Betriebswirtschaft',
  'social_security': 'Sozialversicherung',
  'training_and_work': 'Ausbildung und Arbeit',
  'entrepreneurship': 'Unternehmertum',
  'europe_and_globalization': 'Europa und Globalisierung',
  'consumer_and_contracts': 'Verbraucher und Verträge'
};

const bereiche = [
  { key: 'lernfeld-4', label: 'Ganzheitliche Aufgabe I (Betriebswirtschaftlich-technisch)' },
  { key: 'lernfeld-6', label: 'Ganzheitliche Aufgabe II (Technisch-anwendungsorientiert)' },
  { key: 'wirtschaft', label: 'Wirtschaft' },
];

export default function Statistik({ setToken }) {
  const [selectedType, setSelectedType] = useState('lernen');
  const [categories, setCategories] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedCategories, setExpandedCategories] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('🔄 Lade kategorisierte Fragen...');
      
      const response = await getAllQuestionsByCategories();
      console.log('📥 API Response:', response.data);
      
      setCategories(response.data.categories);
      
    } catch (error) {
      console.error('❌ Fehler beim Laden der Kategorien:', error);
      setError('Fehler beim Laden der Daten: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    if (setToken) setToken(null);
    navigate('/login', { replace: true });
  };

  const handleStatistikClick = () => {
    // Bereits auf der Statistik-Seite, nichts zu tun
  };

  const handleAccountClick = () => {
    navigate('/account');
  };

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  const toggleCategory = (categoryKey) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryKey]: !prev[categoryKey]
    }));
  };

  if (loading) {
    return (
      <div style={{ position: 'relative' }}>
        <div className="background" />
        <Navbar 
          title="Statistiken"
          onLogout={handleLogout}
          logoClickable={true}
          onLogoClick={handleBackToDashboard}
          onStatistikClick={handleStatistikClick}
          onAccountClick={handleAccountClick}
        />
        <div className="statistik-page" style={{ paddingTop: 100 }}>
          <div className="statistik-loading">Lade Daten...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ position: 'relative' }}>
        <div className="background" />
        <Navbar 
          title="Statistiken"
          onLogout={handleLogout}
          logoClickable={true}
          onLogoClick={handleBackToDashboard}
          onStatistikClick={handleStatistikClick}
          onAccountClick={handleAccountClick}
        />
        <div className="statistik-page" style={{ paddingTop: 100 }}>
          <div className="statistik-error">
            <h3>Fehler</h3>
            <p>{error}</p>
            <button onClick={loadCategories} className="retry-button">
              Erneut versuchen
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <div className="background" />
      <Navbar 
        title="Statistiken"
        onLogout={handleLogout}
        logoClickable={true}
        onLogoClick={handleBackToDashboard}
        onStatistikClick={handleStatistikClick}
        onAccountClick={handleAccountClick}
      />
      <div className="statistik-page" style={{ paddingTop: 100 }}>
        <div className="statistik-filter-buttons">
          {statistikTypes.map(type => (
            <button
              key={type.key}
              className={`statistik-filter-btn${selectedType === type.key ? ' selected' : ''}`}
              onClick={() => setSelectedType(type.key)}
            >
              {type.label}
            </button>
          ))}
        </div>
        <div className="statistik-bereiche-list">
          {bereiche.map(bereich => (
            <div className="statistik-bereich-block" key={bereich.key}>
              <div className="statistik-bereich-header">{bereich.label}</div>
              {bereich.key === 'wirtschaft' ? (
                <div className="statistik-kategorien-list">
                  {Object.keys(categories).map(categoryKey => {
                    const questions = categories[categoryKey] || [];
                    const isExpanded = expandedCategories[categoryKey];
                    
                    return (
                      <div key={categoryKey} className="statistik-kategorie-item">
                        <div 
                          className="statistik-kategorie-header"
                          onClick={() => toggleCategory(categoryKey)}
                        >
                          <span className="kategorie-label">
                            {categoryLabels[categoryKey] || categoryKey}
                          </span>
                          <span className="kategorie-count">
                            ({questions.length} Fragen)
                          </span>
                          <span className="expand-icon">
                            {isExpanded ? '▼' : '▶'}
                          </span>
                        </div>
                        {isExpanded && (
                          <div className="statistik-fragen-list">
                            {questions.map(question => (
                              <div key={question.id} className="statistik-frage-item">
                                {question.question_text}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <ul className="statistik-themen-list">
                  <li className="statistik-thema-item">Daten werden geladen...</li>
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 